import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Amazing CloudFlare works</h1>
        <p>Deploy my React Apps to CloudFlare</p>
      </header>
    </div>
  );
}

export default App;
